import $ from 'jquery';
import CountUp from 'countup.js';

var $projectStatsNums = $( '.c-stat-card' );

if ( $projectStatsNums.length ) {
	const getScrollTop = function() {
		return window.pageYOffset ||
			document.documentElement.scrollTop ||
			document.body.scrollTop ||
			0;
	};

	$projectStatsNums.each( function( index, element ) {
		var $element = $( element );
		var $numEl = $( 'strong', $element );
		var endValStr = $numEl.attr( 'data-number' );
		var endVal, type, numAnim;

		if ( endValStr.includes( '.' ) ) {
			endVal = parseFloat( $numEl.attr( 'data-number' ), 2 );
			type = 'float';
		} else {
			endVal = parseInt( $numEl.attr( 'data-number' ), 10 );
			type = 'int';
		}

		var animEndVal = endVal;
		var cb = function() {};

		if ( endVal > 1000 ) {
			animEndVal = endVal - 100;
		}

		if ( type === 'float' ) {
			numAnim = new CountUp( $numEl[ 0 ], 0, animEndVal, 2 );
		} else {
			numAnim = new CountUp( $numEl[ 0 ], 0, animEndVal );
		}

		if ( animEndVal !== endVal ) {
			cb = function() {
				numAnim.update( endVal );
			};
		}

		var animationDone = false;

		var check = function() {
			if ( true === animationDone ) {
				$( window ).off( 'scroll.projectStatsNum.' + index );
				$( window ).off( 'resize.projectStatsNum.' + index );

				return;
			}

			var offset = $element.offset();
			var top = offset.top;
			var scrollTop = getScrollTop();
			var windowHeight = $( window ).height();

			if ( ( top - 100 ) > scrollTop && ( top + 100 ) < ( scrollTop + windowHeight ) ) {
				animationDone = true;
				numAnim.start( cb );
				$( window ).off( 'scroll.projectStatsNum.' + index );
				$( window ).off( 'resize.projectStatsNum.' + index );
			}
		};

		$( window ).on( 'scroll.projectStatsNum.' + index, check );
		$( window ).on( 'resize.projectStatsNum.' + index, check );
		$( check );
	} );
}
